import { TUTORIALS } from "./Tutorials";

const newLine = "<br><br>";
const PAGE_LIST = {
  HOME: "/",
  ANALYZE: "/analyze",
  OPTIMIZATION: "/optimization",
  RESULTS: "/results",
  ACCOUNT: "/me",
};

const TUTORIAL_VALUES = (page, url, t) => {
  const PDF_TAG = `<span style="${{
    fontWeight: "bold",
  }}"><a target="_blank" rel="noopener noreferrer" href="${url}">${t(
    "tutorial.userManual",
  )}</a></span>`;
  switch (page) {
    case PAGE_LIST.HOME:
      return [
        {
          element: "#analyze-header",
          intro:
            t("tutorial.homePage.analyse.clickHere") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },

        {
          element: "#scenarios",
          intro:
            t("tutorial.homePage.scenarios.clickHere") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#results",
          intro:
            t("tutorial.homePage.results.clickHere") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#my-account",
          intro:
            t("tutorial.homePage.myAccount.clickHere") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#help",
          intro: `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    case PAGE_LIST.ANALYZE:
      return [
        {
          element: ".site-to-analyze",
          intro:
            t("tutorial.analyzePage.selectProject") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#scenarios",
          intro:
            t("tutorial.analyzePage.scenarios") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#help",
          intro: `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    case PAGE_LIST.OPTIMIZATION:
      return [
        {
          element: ".site-to-analyze",
          intro:
            t("tutorial.optimisationPage.selectProjet") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".dropdown-trigger",
          intro:
            t("tutorial.optimisationPage.createScenario") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".elsAPa",
          intro:
            t("tutorial.optimisationPage.editScenario") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".gJgWIV",
          intro:
            t("tutorial.optimisationPage.duplicateScenario") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".cTduRZ",
          intro:
            t("tutorial.optimisationPage.deleteScenario") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".ePIZPS",
          intro:
            t("tutorial.optimisationPage.downloadHypothesis") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".control",
          intro:
            t("tutorial.optimisationPage.selectScenario") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".calculate",
          intro:
            t("tutorial.optimisationPage.calculateScenario") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".results",
          intro:
            t("tutorial.optimisationPage.alreadyCalculated") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".is-info",
          intro:
            t("tutorial.optimisationPage.backHome") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".tech",
          intro:
            t("tutorial.optimisationPage.addTech") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".tech-4",
          intro:
            t("tutorial.optimisationPage.configureElecPrice") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".general-settings",
          intro:
            t("tutorial.optimisationPage.generalSettings") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".objective-editor",
          intro:
            t("tutorial.optimisationPage.addConstraints") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".gMEhTS",
          intro:
            t("tutorial.optimisationPage.save") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#help",
          intro: `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    case PAGE_LIST.RESULTS:
      return [
        {
          element: ".site-to-analyze",
          intro:
            t("tutorial.resultsPage.selectProject") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".site-in-scenario-table",
          intro:
            t("tutorial.resultsPage.scenarioDetails") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#help",
          intro: `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    case PAGE_LIST.ACCOUNT:
      return [
        {
          element: ".termsOfService",
          intro:
            t("tutorial.accountPage.termsOfService") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".myContactDetails",
          intro:
            t("tutorial.accountPage.editPersonalInfo") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".fqQORE",
          intro:
            t("tutorial.accountPage.editConnexionInfo") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".plan",
          intro:
            t("tutorial.accountPage.editYourPackage") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".dHVxpI",
          intro:
            t("tutorial.accountPage.editLanguage") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".sites",
          intro:
            t("tutorial.accountPage.displayProjects") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".defaultScenarios",
          intro:
            t("tutorial.accountPage.defaultScenarios") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: ".defaultRates",
          intro:
            t("tutorial.accountPage.defaultRates") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#help",
          intro: `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    case TUTORIALS.NEW_RESULTS_BUTTONS:
      return [
        {
          element: "#export-button",
          intro:
            t("tutorial.resultsButtons.projectFiles") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#reset-layout-button",
          intro:
            t("tutorial.resultsButtons.resetLayout") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    case TUTORIALS.NEW_ACC_ACI:
      return [
        {
          element: "#tuto-aci",
          intro:
            t("tutorial.accAci.aci") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#tuto-acc",
          intro:
            t("tutorial.accAci.acc") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    case TUTORIALS.NEW_TEMPO:
      return [
        {
          element: "#tuto-tempo",
          intro:
            t("tutorial.newTempo.tempo") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#tuto-tempo-prices",
          intro:
            t("tutorial.newTempo.tempoPrice") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
    default:
      return [
        {
          element: "#new-site",
          intro:
            t("tutorial.help") +
            newLine +
            `${t("tutorial.consult")} ${PDF_TAG}`,
        },
        {
          element: "#help",
          intro: `${t("tutorial.consult")} ${PDF_TAG}`,
        },
      ];
  }
};
export default TUTORIAL_VALUES;
